// extracted by mini-css-extract-plugin
module.exports = {"AlignCheckout":"Checkout_AlignCheckout__2d7-3","Checkout":"Checkout_Checkout__2bqWo"};